import React from 'react';
import MuiLink from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import Button, { type ButtonProps } from '@mui/material/Button';

interface Props extends ButtonProps {
    href: string,
    target?: string,
    rel?: string,
    download?: boolean | string,
}

export default function ButtonLink({
    href,
    target,
    rel,
    download,
    children,
    ...props
}: Props) {
    return (
        <MuiLink to={href} target={target} rel={rel} download={download} component={RouterLink}>
            <Button {...props}>{children}</Button>
        </MuiLink>
    );
}
